module.exports = __webpack_public_path__ + "static/media/clubs.4d096f3d.svg";